export default __webpack_public_path__ + "static/media/4k.4106524e.gif";